export const iconNameMapping = (name) => {
    const map = {
      'Outworld Devourer': 'Outworld Destroyer'
    };
  
    return map[name] ? map[name] : name;
}